import React from 'react'
import { ConnectedRouter } from 'react-router-redux'
import { Provider } from 'react-redux'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import { Route, Switch } from 'react-router-dom'
import configureStore, { history } from './store'
import App from './containers/App'

export const store = configureStore()
const persistor = persistStore(store)

const MainApp = () =>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path='/' component={App} />
        </Switch>
      </ConnectedRouter>
    </PersistGate>
  </Provider>

export default MainApp



// WEBPACK FOOTER //
// ./MainApp.js